import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

const INSURER_GROUPS = [
  UserGroup.INSURER_ADMINISTRATOR,
  UserGroup.INSURER_CUSTOMER_SUPPORT,
  UserGroup.INSURER_UNDERWRITER,
  UserGroup.INSURER_COMMERCIAL_MANAGER,
  UserGroup.INSURER_SALES_EXECUTIVE,
  UserGroup.INSURER_COMMERCIAL_ASSISTANT,
];

/**
 * Qualquer perfil da seguradora — espelha o `isInsurerUser` do backend.
 *
 * Mais amplo que `useIsUnderwriterUser`, que exige `insurer.underwriter`.
 * Use este quando o gate precisa bater com o do backend; usar o do subscritor
 * esconderia o recurso do administrador, que a rota de análise deixa entrar.
 */
export function useIsInsurerUser() {
  const { checkUserGroups } = useAuth();
  const [isInsurerUser, setIsInsurerUser] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups(INSURER_GROUPS);
      setIsInsurerUser(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { isInsurerUser, isLoading };
}
